module.exports = __webpack_public_path__ + "media/images/activity_feed_banner-4fd15414.svg";